import { UIInput } from 'types/uiTypes';

import { transitionRFXRequestMutation } from '../mutations/transitionRFXRequestMutation';

export interface TransitionRFXRequestInput extends UIInput {
  rfxId: string;
  revision: number;
  toStateName: string;
  reason?: string;
}

export async function transitionRFXRequest({
  apolloClient,
  rfxId,
  revision,
  toStateName,
  reason
}: TransitionRFXRequestInput): Promise<void> {
  const variables = {
    rfxRequestRevisionedId: {
      id: {
        value: rfxId
      },
      revision
    },
    toStateName,
    reason
  };

  await apolloClient.mutate({
    mutation: transitionRFXRequestMutation,
    variables
  });
}
